import { useEffect } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import Layout from './components/Layout';
import NotFound from './pages/NotFound/NotFound';
import SpeechTopicListPage from './pages/SpeechTopicListPage/SpeechTopicListPage';
import ContentProtectionDemo from './pages/ContentProtectionDemo/ContentProtectionDemo';
import PublicTopicListPage from './pages/PublicTopicListPage/PublicTopicListPage';
import RedeemSuccessPage from './pages/RedeemSuccessPage/RedeemSuccessPage';
import AdminLoginPage from './pages/AdminLoginPage/AdminLoginPage';
import AdminDashboardPage from './pages/AdminDashboardPage/AdminDashboardPage';
import { MemberProvider } from './contexts/MemberContext';
import { PUBLIC_CATALOG_MODE } from './config/public-mode';
import { ADMIN_DASHBOARD_PATH, ADMIN_LOGIN_PATH } from './config/admin-routes';
import IcpFooter from './components/IcpFooter';

// 路由切换时回到页面顶部，避免返回主题列表时停留在列表底部
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const RoutesComponent = () => {
  return (
    <MemberProvider>
      <ScrollToTop />
      <Routes>
        {/* 公开页面 - 首页为公开主题列表 */}
        <Route index element={<PublicTopicListPage />} />
        <Route path="topics" element={<Navigate to="/" replace />} />
        <Route path="success" element={PUBLIC_CATALOG_MODE ? <Navigate to="/" replace /> : <RedeemSuccessPage />} />
        
        {/* 管理员后台：旧 /admin、/admin/dashboard 不做兼容跳转，落到下方 * 渲染 404 */}
        <Route path={ADMIN_LOGIN_PATH.replace(/^\//, '')} element={<AdminLoginPage />} />
        <Route
          path={ADMIN_DASHBOARD_PATH.replace(/^\//, '')}
          element={<AdminDashboardPage />}
        />
        
        {/* 原有的页面 */}
        <Route element={<Layout />}>
          <Route path="speech-topics" element={PUBLIC_CATALOG_MODE ? <Navigate to="/" replace /> : <SpeechTopicListPage />} />
          <Route path="content-protection" element={PUBLIC_CATALOG_MODE ? <Navigate to="/" replace /> : <ContentProtectionDemo />} />
        </Route>
        
        <Route path="*" element={<NotFound />} />
      </Routes>
      <IcpFooter />
    </MemberProvider>
  );
};

export default RoutesComponent;
